import React from 'react'

const TrendingEvents = () => {
  return (
    <div>TrendingEvents</div>
  )
}

export default TrendingEvents